._ClientGroupDetailView_eloeu_1 {
  /* Empty file & class, used as a placeholder for future styling */
}